export enum PopupType {
    TOP, LEFT, BOTTOM, RIGHT,NONE
}
